import React from 'react'

const Spinner = () => {
  return (
    <div className=' flex h-screen flex-col justify-center items-center '>
          <div className='spinner'></div>
    </div>
  )
}

export default Spinner;